const type = "ALERTS/";

export const alertsConstants = {
  ALERT_LISTING_REQUEST: `${type}ALERT_LISTING_REQUEST`,
  ALERT_LISTING_SUCCESS: `${type}ALERT_LISTING_SUCCESS`,
  ALERT_LISTING_FAILURE: `${type}ALERT_LISTING_FAILURE`,
  
  ALERT_SAVE_REQUEST: `${type}ALERT_SAVE_REQUEST`,
  ALERT_SAVE_SUCCESS: `${type}ALERT_SAVE_SUCCESS`,
  ALERT_SAVE_FAILURE: `${type}ALERT_SAVE_FAILURE`,
  
  ALERT_DELETE_REQUEST: `${type}ALERT_DELETE_REQUEST`,
  ALERT_DELETE_SUCCESS: `${type}ALERT_DELETE_SUCCESS`,
  ALERT_DELETE_FAILURE: `${type}ALERT_DELETE_FAILURE`,

};
